<template>
<v-container fluid>
    <v-row>
        <v-col>
            <v-btn color="blue" class="mx-4 white--text" @click="handleSubmitFile" :disabled="!fileLoaded">Submit Data</v-btn>
            <v-btn @click="handleClearFile" outlined :disabled="!fileLoaded">Clear File</v-btn>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
                <div v-if="!fileLoaded">
                <input
                    id="file-input-button"
                    class="hidden"
                    type="file"
                    @change="handleChangeFile"
                />
                <div
                    class="draghere text-center"
                    :class="{ 'file-hover': fileHovering }"
                    @drop="handleFileDrop"
                    @dragover="handleDragOver"
                    @dragleave="handleLeaveHover"
                >
                    <p>
                    Drop your file here or
                    <span class="pretend-link" @click="handleClickHere">CLICK HERE</span>
                    to select a file from your system.
                    </p>
                    <p>
                    You can download a template
                    <a
                        class="pretend-link"
                        href="\files\cosellers_customers_template.csv"
                        download="cosellers_customers_template.csv"
                        >HERE</a
                    >
                    if you need one.
                    </p>
                </div>
                
                </div>
                <div v-else>
                    <FileContents :rows="rows" />
                </div>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import { csvParse } from 'd3-dsv'
import FileContents from './importer/FileContents.vue'
import axios from 'axios'

export default {
    name: 'Importer',
    components: { FileContents },
    props: {},
    data() {
        return {
            rows: [],
            fileLoaded: false,
            fileName: '',
            fileHovering: false,
            fileSubmitted: false,
        };
    },
    methods: {
        handleDragOver: function (e) {
            // Necessary to prevent opening the file in the browser instead of importing it
            e.preventDefault();
            this.fileHovering = true;
        },
        handleLeaveHover: function (e) {
            this.fileHovering = false;
        },
        handleFileDrop: function (e) {
            // Accepts the file if it's dropped
            e.preventDefault();
            this.handleLoadCSV(e.dataTransfer.files[0]);
        },
        handleChangeFile: function (e) {
            // Accepts the file if it's loaded via button click
            this.handleLoadCSV(e.target.files[0]);
        },
        handleClickHere: function () {
            window.document.getElementById('file-input-button').click();
        },
        handleClearFile: function () {
            // Clears the loaded file/resets the form
            this.fileLoaded = false;
            this.fileSubmitted = false;
            this.fileName = '';
            this.rows = [];
            this.new_rows = [];
        },
        handleLoadCSV: function (file) {
            // Standard CSV load using d3-dsv
            const fr = new FileReader();
            this.fileName = file.name;
            fr.readAsText(file);
            fr.addEventListener('load', () => {
                // Read the data from the FileReader result on it's 'load' event
                let data = csvParse(fr.result);
                this.rows = [...data];
                // Create a copy so that new_columns and columns don't point at the same reference.
                this.new_columns = [...data.columns];
                this.columns = data.columns;
                this.fileLoaded = true;
                this.$toast.success(`Succesfully loaded contents of "${file.name}".`)
            });
        },
        handleSubmitFile: function () {
            // pretend to submit, get response
            const url = `${this.$store.getters.baseURL}/api/user/${this.$store.state.id}/matrix/update/`
            const { rows } = this
            axios({
                method: 'post',
                url: url,
                data: { rows },
                headers: {
                    'Authorization': `Token ${this.$store.state.userToken}`
                }
            }).then((res) => {
                this.$toast.success("Successfully submitted data.")
                this.$store.commit('setMatrixReloadNeeded', true)
                const { messages } = res.data
                this.rows = this.rows.map(row => {
                    row.message = messages[row.domain_name.trim()]
                    return row
                })
            }).catch((err) => {
                console.error(err)
                this.$toast.error("Unable to submit data.")
            })            
        }
    },
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.draghere {
    padding: 12px;
  max-width: 100%;
  margin: 12px;
  height: 250px;
  border: 4px dashed #1e88e5;
  border-radius: 12px;
  color: #212121;
  font-size: 2em;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 200ms ease-in-out;
}

.overflow-hidden {
  overflow: hidden;
}

hr {
  margin-top: 4.5em;
  border-top: 1px solid hsla(0, 0%, 76%, 1);
}

.file-hover {
  background-color: #eeeeee;
  transition: 300ms background-color linear;
}

.file-hover:hover {
    background-color: #e0e0e0;
}

.vertical-spacing {
  margin: 1.5em -15px;
}

.pretend-link {
  cursor: pointer;
  transition: all 200ms ease-in-out;
  color: #1976d2;
}

.pretend-link:hover {
  font-weight: 600;
}
</style>